<template>
  <div>
    <div class="header-section">
      <div>
        <h1 class="header-style">
          Projects
        </h1>
        <br>
        <p class="subheader-style">
          Select a project for further process
        </p>
      </div>
    </div>
    <br>
    <div class="listing-users">
      <div
        v-for="item in projectsList"
        :key="item.first_name"
        class="lists"
      >
        <div>
          <v-row
            class="listing-section"
            @click="nextPage(item.id)"
          >
            <v-col cols="11">
              <div class="profile-style">
                <span>{{ item.name }}</span>
              </div>
            </v-col>
            <v-col cols="1">
              <v-icon color="#37474f">
                mdi-chevron-right
              </v-icon>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
    <centre-spinner :loading="loading" />
  </div>
</template>

<script>
import spinner from '../../../components/SpinnerCentre.vue';
export default {
  name: 'SelectProject',
  components: {
    'centre-spinner': spinner,
  },
  data () {
    return {
      loading: false,
    };
  },
  computed: {
    deviceData () {
      return this.$store.getters.getDeviceData;
    },
    projectsList () {
      return this.$store.getters['devices/getProjectsList'];
    },
    getWorker () {
       return this.$store.getters.getWorker;
      },
  },
  async mounted () {
    this.loading = true;
    await this.checkUserExist();
    await this.loadOnMount();
    this.loading = false;
  },
  methods: {
    nextPage (id) {
      this.loading = true;
      setTimeout(() => {
        this.$emit('selected-project', id);
      }, 1000);
    },
    async loadOnMount () {
      this.loading = true;
      const orgExtId = await this.deviceData.organization_id.external_id;
       await this.$store.dispatch('devices/fetchProjectsList', { orgExtId });
      this.loading = false;
      },
      checkUserExist () {
        if (Object.keys(this.getWorker).length === 0) {
          this.$store.dispatch('kioskUserLogout');
          this.$router.push({ name: 'DeviceCheckInCheckOut' });
        }
      },
  },
};
</script>

<style scoped>
.header-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.listing-users {
  width: 100%;
  border-radius: 40px;
  padding: 10px 10px;
  background: #e7e7e7;
  height: calc(100vh - 13rem);
  overflow-y: auto;
}

.lists {
  width: 100%;
  margin-bottom: 5px;
  padding: 10px 13px;
  border-radius: 100px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.582);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.445);
}

.lists:hover {
  background: #e7e7e7;
}

.listing-section {
  display: flex;
  align-items: center;
}

.profile-style {
  display: flex;
  gap: 20px;
  align-items: center;
  padding: 15px;
}

.short-letter-style {
  color: white;
}
</style>
